import { Box, Stack, Steps, Tabs } from '@welbe/design-system';
import { useContext } from 'react';
import { CandidateContext, ICandidate } from '../../CandidateFormProvider';

const steps = [
	{ title: 'Datos candidato', description: 'Editar candidato' },
	{ title: 'Citas médicas', description: 'Editar Citas' },
];

export const Navigation = () => {
	const { activeStep, setActiveStep, completeStep, isEditing } =
		useContext<ICandidate>(CandidateContext);

	if (isEditing) {
		return (
			<Box gridArea="header" bg="white" p="40px" pb="0">
				<Tabs.Root
					variant="enclosed"
					value={String(activeStep)}
					onValueChange={(details: { value: string }) =>
						setActiveStep(Number(details.value))
					}
					width="100%"
				>
					<Tabs.List width="100%">
						{steps.map((s, i) => (
							<Tabs.Trigger key={i} value={String(i)} flex="1">
								{s.title}
							</Tabs.Trigger>
						))}
					</Tabs.List>
				</Tabs.Root>
			</Box>
		);
	}

	return (
		<Box gridArea="header" bg="white" p="40px" pb="0">
			<Steps.Root
				count={steps.length}
				step={activeStep}
				onStepChange={(details: { step: number }) => {
					if (activeStep < completeStep) setActiveStep(details.step);
				}}
			>
				<Steps.List>
					{steps.map((s, i) => (
						<Steps.Item key={i} index={i}>
							<Steps.Trigger>
								<Steps.Indicator>
									<Steps.Number />
								</Steps.Indicator>
								<Stack gap="0">
									<Steps.Title>{s.title}</Steps.Title>
									<Steps.Description>{s.description}</Steps.Description>
								</Stack>
							</Steps.Trigger>
							<Steps.Separator />
						</Steps.Item>
					))}
				</Steps.List>
			</Steps.Root>
		</Box>
	);
};
